const ribbon = "_uxsr1j692xz";
const iconCls = "_uxsi1t1hbim";

export { iconCls, ribbon };
import "./atom.ribbon.style.linaria.module.css";
//# sourceMappingURL=atom.ribbon.style.js.map
